<template>
  <button class="btn button" :class="this.type" :aria-label="text"
  @click="clicked()">
    <span v-if="this.type === 'hasIcon'"  class="icon mobileIcon">
      <font-awesome-icon :icon="icon" />
    </span>
    <span v-if="this.type === 'hasIcon'" class="mobileText">
      {{this.text}}
    </span>
    <span v-if="this.type !== 'hasIcon'">
      {{this.text}}
    </span>
  </button>
</template>

<script>
export default {
  props: {
    text: String,
    icon: Array,
    type: String,
  },

  computed: {
    isLoggedIn() {
      return this.$store.getters['User/is_loggedin'];
    },
  },
  methods: {
    clicked() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.button { margin: .2rem; }
span { white-space: nowrap; }
@media (max-width: 600px) {
  .mobileText { display: none; }
  .mobileIcon { margin-left: 0 !important; margin-right: 0 !important; }
}
</style>
